import { Workbox } from 'workbox-window';

class WorkboxService {
  constructor() {
    this.wb = null;
    this.registration = null;
  }

  // ##### REGISTER SERVICE WORKER
  async register() {
    if ('serviceWorker' in navigator) {
      try {
        this.wb = new Workbox('/service-worker.js');

        this.wb.addEventListener('installed', (event) => {
          if (event.isUpdate) {
            console.log('Service Worker updated');
          } else {
            console.log('Service Worker installed');
          }
        });

        // ##### AUTO-RELOAD when new service worker is waiting
        this.wb.addEventListener('waiting', () => {
          console.log('Service Worker waiting for update - reloading page');
          // Automatically skip waiting and reload to get new version
          this.wb.messageSkipWaiting();
          window.location.reload();
        });

        // ##### HANDLE CONTROLLING - When service worker takes control
        this.wb.addEventListener('controlling', () => {
          console.log('Service Worker is now controlling the page');
          // Reload if this is an update
          if (this.registration?.update) {
            window.location.reload();
          }
        });

        this.wb.addEventListener('activated', (event) => {
          if (!event.isUpdate) {
            console.log('Service Worker activated');
          }
        });

        this.registration = await this.wb.register();
        console.log('Service Worker registered:', this.registration);

        // ##### CHECK FOR UPDATES on load
        // This ensures we detect new service worker immediately
        if (this.registration) {
          this.registration.update();
        }

        return this.registration;
      } catch (error) {
        console.error('Failed to register Service Worker:', error);
        return null;
      }
    } else {
      console.warn('Service Worker not supported');
      return null;
    }
  }

  // ##### UPDATE SERVICE WORKER
  async update() {
    if (this.wb) {
      await this.wb.update();
    }
  }

  // ##### SKIP WAITING
  async skipWaiting() {
    if (this.registration && this.registration.waiting) {
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }
}

// ##### EXPORT SINGLETON
const workboxService = new WorkboxService();
export default workboxService;
